
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

export default function SurveyLandingPage() {

  const { kode_toko } = useParams();

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
const [namaToko, setNamaToko] = useState("");

useEffect(() => {

  const fetchStore = async () => {

    try {

      const res = await fetch(
        `/api/traffic/master-toko/${kode_toko}`
      );

      const json = await res.json();

      if (json.success) {
        setNamaToko(json.data.nama_toko);
      }

    } catch (err) {

      console.error(err);

    }
  };

  if (kode_toko) {
    fetchStore();
  }

}, [kode_toko]);

  const [form, setForm] = useState({
    totalVisitors: 1,
    customerType: "", // Pernah / Baru
    source: "",
    reason: "",
  });

  // VALIDASI
  const isValid =
    form.customerType &&
    form.reason &&
    (
      form.customerType === "Pernah" ||
      form.source
    );

  // SUBMIT
  const handleSubmit = async () => {

    try {

      if (!isValid) return;

      setLoading(true);

      const payload = {
        kode_toko,

        // backend expects boolean
       

           first_visit:
    form.customerType === "Baru",

  // source hanya untuk customer baru
  source:
    form.customerType === "Baru"
      ? form.source
      : "Existing Customer",

        visit_reason: form.reason,

        total_visitors:
          form.totalVisitors,
      };

      console.log("PAYLOAD:", payload);

      const res = await fetch(
        "/api/traffic/survey",
        {
          method: "POST",
          headers: {
            "Content-Type":
              "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const json = await res.json();

      if (!res.ok) {
        throw new Error(
          json.message ||
            "Gagal submit survey"
        );
      }

      setSuccess(true);

    } catch (err) {

      console.error(err);

      alert(err.message);

    } finally {

      setLoading(false);

    }
  };

  // SUCCESS PAGE
  if (success) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-500 to-blue-500 p-6">

        <div className="bg-white rounded-3xl p-8 text-center shadow-2xl max-w-sm w-full">

          <div className="text-5xl mb-4">
            🎉
          </div>

          <h1 className="text-xl font-bold text-gray-800">
            Terima kasih!
          </h1>

          <p className="text-sm text-gray-500 mt-2">
            Jawaban kamu sudah tersimpan.
          </p>

          <div className="mt-6 text-xs text-gray-400">
            Nama Toko: {kode_toko}
          </div>

        </div>

      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-500 to-blue-500 flex items-center justify-center p-4">

      <div className="w-full max-w-md bg-white rounded-3xl shadow-2xl overflow-hidden">

        {/* HEADER */}
        <div className="bg-gradient-to-r from-indigo-600 to-blue-500 p-6 text-white">

          <h1 className="text-xl font-bold">
            Customer Survey
          </h1>

          <p className="text-xs text-indigo-100 mt-1">
            Bantu kami improve pengalaman kamu 🙌
          </p>

        </div>

        {/* BODY */}
        <div className="p-5 space-y-5">

          {/* STORE */}
          <div className="text-xs text-gray-400">
            Store ID: {kode_toko}
          </div>

          {/* JUMLAH PENGUNJUNG */}
          <div>

            <label className="text-sm font-semibold text-gray-700">
              Jumlah pengunjung
            </label>

            <div className="flex items-center justify-between mt-2 border rounded-xl p-2">

              <button
                type="button"
                onClick={() =>
                  setForm((prev) => ({
                    ...prev,
                    totalVisitors:
                      Math.max(
                        1,
                        prev.totalVisitors - 1
                      ),
                  }))
                }
                className="w-10 h-10 rounded-lg bg-gray-100 hover:bg-gray-200 transition"
              >
                -
              </button>

              <div className="text-lg font-semibold">
                {form.totalVisitors}
              </div>

              <button
                type="button"
                onClick={() =>
                  setForm((prev) => ({
                    ...prev,
                    totalVisitors:
                      prev.totalVisitors + 1,
                  }))
                }
                className="w-10 h-10 rounded-lg bg-gray-100 hover:bg-gray-200 transition"
              >
                +
              </button>

            </div>

          </div>

          {/* PERNAH BELANJA */}
          <div>

            <label className="text-sm font-semibold text-gray-700">
              Pernah belanja di 3Second?
            </label>

            <div className="flex gap-2 mt-2">

              {["Pernah", "Baru"].map(
                (item) => (
                  <button
                    key={item}
                    type="button"
                    onClick={() =>
                      setForm((prev) => ({
                        ...prev,
                        customerType: item,
                        source: "",
                      }))
                    }
                    className={`flex-1 py-2 text-sm rounded-xl border transition ${
                      form.customerType === item
                        ? "bg-indigo-600 text-white border-indigo-600"
                        : "bg-white"
                    }`}
                  >
                    {item}
                  </button>
                )
              )}

            </div>

          </div>

          {/* SOURCE */}
          {form.customerType === "Baru" && (
            <div>

              <label className="text-sm font-semibold text-gray-700">
                Tahu dari mana?
              </label>

              <div className="grid grid-cols-2 gap-2 mt-2">

                {[
                  "IG",
                  "TikTok",
                  "Teman",
                  "Komunitas",
                  "Lewat",
                  "KOL",
                  "WA",
                  "Travel Driver",
                ].map((item) => (
                  <button
                    key={item}
                    type="button"
                    onClick={() =>
                      setForm((prev) => ({
                        ...prev,
                        source: item,
                      }))
                    }
                    className={`py-2 text-sm rounded-xl border transition ${
                      form.source === item
                        ? "bg-indigo-600 text-white border-indigo-600"
                        : "bg-white"
                    }`}
                  >
                    {item}
                  </button>
                ))}

              </div>

            </div>
          )}

          {/* REASON */}
          <div>

            <label className="text-sm font-semibold text-gray-700">
              Datang karena
            </label>

            <div className="grid grid-cols-3 gap-2 mt-2">

              {[
                "Event",
                "Promo",
                "Kebutuhan",
              ].map((item) => (
                <button
                  key={item}
                  type="button"
                  onClick={() =>
                    setForm((prev) => ({
                      ...prev,
                      reason: item,
                    }))
                  }
                  className={`py-2 text-sm rounded-xl border transition ${
                    form.reason === item
                      ? "bg-indigo-600 text-white border-indigo-600"
                      : "bg-white"
                  }`}
                >
                  {item}
                </button>
              ))}

            </div>

          </div>

          {/* SUBMIT */}
          <button
            onClick={handleSubmit}
            disabled={!isValid || loading}
            className={`w-full py-3 rounded-xl font-semibold transition ${
              isValid
                ? "bg-indigo-600 text-white hover:bg-indigo-700"
                : "bg-gray-200 text-gray-400 cursor-not-allowed"
            }`}
          >
            {loading
              ? "Mengirim..."
              : "Kirim Survey"}
          </button>

        </div>

      </div>

    </div>
  );
}